import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './meetings.json';

const Meetings = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Business meeting vocabulary, agendas, and professional English. B2 level grammar, vocabulary, and speaking practice."
            level="B2"
            title="Meetings"
            image="/Images/teams-meeting.webp"
            seoTitle="Free English Lesson Plans: Meetings"
            seoDescription="Business meeting vocabulary, agendas, and professional English. B2 level grammar, vocabulary, and speaking practice."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Meetings;


